import React, { Suspense } from 'react'
import { useQuery } from '@apollo/react-hooks'

import { LoadingComponent } from '../../loading'
import { LoadingModal as LoadingPanel } from '../../loading/modal'
import EnterAccountPasswordWrapper from '../../../modules/enter-account-password-modal/enter-account-password-wrapper'
import { checkQueryStatus } from '../../../lib/utils'
import ACCOUNT_QUERY_WITH_DIR from '../../../../graphql/queries/account-with-directives.gql'
import styles from './index.css'

const SubscriptionAndPayment = React.lazy(() => import('./subscription-and-payment'))

function SubscriptionAndPaymentContent() {
  const accountQuery = useQuery(ACCOUNT_QUERY_WITH_DIR, {
    variables: {
      withSubscription: true,
      withClearCachedSubscriptions: true,
      withCreditcards: true
    },
    fetchPolicy: 'network-only'
  })

  if (checkQueryStatus(accountQuery)) {
    // Show the page loading panel while account data is loading.
    return (
      <div className={styles.loadingPanelWrapper}>
        <LoadingPanel />
      </div>
    )
  }

  const activeSubscription = accountQuery.data?.account?.subscription

  return (
    <SubscriptionAndPayment
      activeSubscription={activeSubscription}
      handleUpdateSubscription={accountQuery.refetch}
    />
  )
}

const AsyncSubscriptionAndPayment = () => (
  // Require account password before showing subscription and payment details.
  <EnterAccountPasswordWrapper>
    <Suspense fallback={<LoadingComponent />}>
      <SubscriptionAndPaymentContent />
    </Suspense>
  </EnterAccountPasswordWrapper>
)

export default AsyncSubscriptionAndPayment
